/**
 * Slice 56 / stage 3 — the one calm grey line about signal. No button, no alarm, no red.
 * It shows while there is no signal or anything saved is still sending, and goes when everything has sent.
 */
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTranslation } from "@/hooks/useTranslation";
import { useOfflineStatus } from "@/hooks/useOfflineStatus";

export function OfflineLine({ className }: { className?: string }) {
  const { t } = useTranslation();
  const { line } = useOfflineStatus();
  if (line === "none") return null;

  const text =
    line === "offline"
      ? t("offlineBanner")
      : line === "weak"
        ? t("offlineWeak")
        : line === "sending"
          ? t("offlineSending")
          : line === "reopened"
            ? t("offlineReopened")
            : t("offlineSent");

  if (line === "sent") {
    return (
      <div className={cn("flex items-center gap-2 rounded-[12px] bg-[#e2eeed] px-3 py-2 text-[13.5px] font-bold text-[#15776d]", className)}>
        <Check className="h-4 w-4" strokeWidth={3} />
        {text}
      </div>
    );
  }
  return (
    <div className={cn("flex items-center gap-2.5 rounded-[12px] bg-[#eef2f5] px-3 py-2", className)} role="status">
      <span className="h-2 w-2 shrink-0 rounded-full bg-[#94a3b0]" />
      <span className="text-[13.5px] font-medium leading-snug text-[#64748b]">{text}</span>
    </div>
  );
}
